<template>
    <div>
        <loading-progress-bar v-if="loading" :loading="loading" color="secondary"></loading-progress-bar>
        <v-card v-if="!loading" flat>
            <v-card-title class="accent white--text title" v-if="title">
                {{ title | translate }}
            </v-card-title>
            <v-card-text v-if="!loading&&template">
                <runtime-template-compiler :template="template" :parent="parentComponent"/>
            </v-card-text>
        </v-card>
    </div>
</template>

<script>
import {callAPI} from '@/helper'
import LoadingProgressBar from './../LoadingProgressBar'
import {RuntimeTemplateCompiler} from "vue-runtime-template-compiler"

export default {
    props: {
        title: {type: String, default: null},
        svg: {type: String, default: null},
        latestOnly: {type: Boolean, default: false},
    },
    components: {LoadingProgressBar,RuntimeTemplateCompiler},
    name: 'BmsWidget',
    data: function () {
        return {
            loading: true,
            template: null,
            points: null,
            parentComponent: this,
            interval:null,
        }
    },
    mounted() {
        let me=this
        if(this.svg&&this.svg!==""){
            let newTemplate=this.svg
            let ids=newTemplate.match(/id="(.*?)"/g)
            if (ids){
                for (let id of ids){
                    if (id.startsWith('id="carnot--')){
                        let splitId=id.slice(0, -1).split("--")
                        if(!splitId[3]){

                            newTemplate=newTemplate.replaceAll(id,"v-text=\"points['"+splitId[1]+" - "+splitId[2]+"'] ? points['"+splitId[1]+" - "+splitId[2]+"'].value : ''\"")
                        } else if (splitId[3]==="show"){
                            newTemplate=newTemplate.replaceAll(id,"v-show=\"points['"+splitId[1]+" - "+splitId[2]+"']&&points['"+splitId[1]+" - "+splitId[2]+"'].value\"")
                        } else if (splitId[3]==="hide"){
                            newTemplate=newTemplate.replaceAll(id,"v-show=\"!points['"+splitId[1]+" - "+splitId[2]+"']||!points['"+splitId[1]+" - "+splitId[2]+"'].value\"")
                        }
                    }
                }
            }
            me.template=newTemplate
            me.refresh()
            me.interval = setInterval(function () {
                me.refresh()
            }, 30000);
        }
    },
    beforeDestroy: function(){
        clearInterval(this.interval)
    },
    methods: {
        isFloat(n) {
            return Number(n) === n && n % 1 !== 0;
        },
        async refresh() {
            let data = await callAPI(
                "latest-readings/",
                {
                    latest_only:this.latestOnly
                },
                'post'
            )
            let newPoints = {}
            for (let item of data.data.result) {
                item.equipment_name = item.equipment_name.replaceAll("%", "_")
                item.equipment_name = item.equipment_name.replaceAll("/", "_")
                item.equipment_name = item.equipment_name.replaceAll("(", "_")
                item.equipment_name = item.equipment_name.replaceAll(")", "_")
                item.equipment_name = item.equipment_name.replaceAll(" ", "_")
                item.sensor_name = item.sensor_name.replaceAll("%", "_")
                item.sensor_name = item.sensor_name.replaceAll("/", "_")
                item.sensor_name = item.sensor_name.replaceAll("(", "_")
                item.sensor_name = item.sensor_name.replaceAll(")", "_")
                item.sensor_name = item.sensor_name.replaceAll(" ", "_")
                newPoints[item.equipment_name + " - " + item.sensor_name] = {
                    value: item.value && this.isFloat(item.value) ? item.value.toFixed(2) : item.value,
                    unit: item.unit,
                    equipment_id: item.equipment_id,
                    equipment_name: item.equipment_name,
                    sensor_name: item.sensor_name
                }
            }
            this.points = newPoints
            this.loading = false
        },
    },
}
</script>

<style scoped>

</style>
